import React, { Fragment, useContext } from 'react';
import loadable from '@loadable/component';
import FullScreenLoader from '../../FullScreenLoader';
import Modal from '../../Modal';
import { MODALS } from '../../../constants';
import { Context } from '../../../context/AppContext';

const SlideMenuLoadable = loadable(() => import('./SlideMenuLoadable'), {
  fallback: <FullScreenLoader />,
});

const SlideMenu = ({ hideReview }) => {
  const {
    media: { desktop },
    modal: { showModal },
  } = useContext(Context);

  return (
    <Fragment>
      <button
        className="Header__SlideMenu__button"
        onClick={() => showModal(MODALS.HEADER_SLIDE_MENU)}
        style={{ padding: '8px 18px 5px 7px' }}
      >
        <i
          className="icon-generalmenu"
          style={{
            fontSize: '30px',
            fontWeight: '600',
            position: 'relative',
            color: 'black',
          }}
        />
      </button>
      <Modal
        name={MODALS.HEADER_SLIDE_MENU}
        animation={desktop ? 'SlideMenuScale' : 'ModalScale'}
      >
        <SlideMenuLoadable hideReview={hideReview} />
      </Modal>
    </Fragment>
  );
};

export default SlideMenu;
